import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TYPE_ON_SHARE_OK,
    addUserPoint,
} from '../actions';
import {pointTypes} from "../util/pointConfig";

export function onShareOK(action$, store) {
    return action$.ofType(ACTION_TYPE_ON_SHARE_OK)
        // .filter(q => store.getState().userReducer.data[0]['vip_code'].slice(0,2) === pointTypes.SHARE_WECHAT.limitMall //武汉
        // && store.getState().userReducer.todayWxShareNum < pointTypes.SHARE_WECHAT.limitNum) //当日限制
        .filter(q => store.getState().userReducer.data[0]['vip_code'].slice(0,2) === pointTypes.LIGHT_SOUP_SHARE.limitMall //武汉
            && store.getState().userReducer.todayWxShareNum < pointTypes.LIGHT_SOUP_SHARE.limitNum) //当日限制
        .mergeMap(() => Observable.merge(
            Observable.of(addUserPoint(pointTypes.LIGHT_SOUP_SHARE.point, pointTypes.LIGHT_SOUP_SHARE.remark, pointTypes.LIGHT_SOUP_SHARE.type)),
        ));
}



// WEBPACK FOOTER //
// ./src/epics/wxShare.js